import { createContext, useCallback, useEffect, useMemo, useState } from 'react'

interface CookieContextType {
  showCookieBanner: boolean
  acceptCookies: () => void
}

const COOKIE_NAME = 'qureos-cookie'
const COOKIE_EXPIRY_DAYS = 7

const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop()?.split(';').shift() || null
  return null
}

const setCookie = (name: string, value: string, days: number) => {
  const date = new Date()
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
  const expires = `expires=${date.toUTCString()}`
  document.cookie = `${name}=${value};${expires};path=/`
}

export const CookieContext = createContext<CookieContextType>({
  showCookieBanner: false,
  acceptCookies: () => {}
})

export const CookieProvider = ({ children }: { children: React.ReactNode }) => {
  const [showCookieBanner, setShowCookieBanner] = useState<boolean>(false)

  useEffect(() => {
    const cookieValue = getCookie(COOKIE_NAME)
    if (!cookieValue) {
      setShowCookieBanner(true)
    }
  }, [])

  const acceptCookies = useCallback(() => {
    setCookie(COOKIE_NAME, 'accepted', COOKIE_EXPIRY_DAYS)
    setShowCookieBanner(false)
  }, [])

  const contextValue = useMemo(
    () => ({
      showCookieBanner,
      acceptCookies
    }),
    [showCookieBanner, acceptCookies]
  )

  return (
    <CookieContext.Provider value={contextValue}>
      {children}
    </CookieContext.Provider>
  )
}
